import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';

export const getNodesFromAPI = async (index) => {
    const apiUrl = new URL(`${settings.urls.apiDomain}/core/v1/zones/nodes/${index}/`, window.location.origin);
    try {
        const res = await axFetch.get(apiUrl.toString());
        return res.data;
    } catch (error) {
        return undefined;
    }
};
